// TO2DO: better naming for actions

// Auth
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SET_USER_LOADED = "SET_USER_LOADED";

// Project
export const PROJECT = "PROJECT";
export const SOLUTION = "SOLUTION";
export const IMPORT_SERVICES = "IMPORT_SERVICES";
export const SET_VEHICLES = "SET_VEHICLES";
export const SET_VEHICLE_TYPES = "SET_VEHICLE_TYPES";
export const SELECTED_VEHICLES = "SELECTED_VEHICLES";
export const SET_CURRENT_VEHICLE_SELECTION = "SET_CURRENT_VEHICLE_SELECTION";
export const CHANGED_VEHICLES = "CHANGED_VEHICLES";
export const SET_DRIVERS = "SET_DRIVERS";
export const SET_DRIVER_LOCATIONS = "SET_DRIVER_LOCATIONS";
export const CLEAR_DRIVER_LOCATIONS = "CLEAR_DRIVER_LOCATIONS";
export const SELECTED_ROUTES = "SELECTED_ROUTES";
export const EXPANDED_ROUTES = "EXPANDED_ROUTES";
export const EMPTY_ROUTES = "EMPTY_ROUTES";
export const PUBLICATION_SETTINGS = "PUBLICATION_SETTINGS";
export const LOCKED_ROUTES = "LOCKED_ROUTES";
export const RESET_STATE = "RESET_STATE";
export const SET_PROJECT_DETAILS = "SET_PROJECT_DETAILS";
export const EXPANDED_FROM_MAP = "EXPANDED_FROM_MAP";
export const SET_PROJECT_STARTED = "SET_PROJECT_STARTED";
export const SET_SHOWING_ROUTE_ID = "SET_SHOWING_ROUTE_ID";

// Loading
export const LOADING_DRAWER = "LOADING_DRAWER";
export const LOADING_PROJECT = "LOADING_PROJECT";
export const LOADING_PROJECT_INITIAL = "LOADING_PROJECT_INITIAL";
export const LOADING_ROUTES_LIST = "LOADING_ROUTES_LIST";
export const LOADING_IMPORT = "LOADING_IMPORT";
export const LOADING_UNSCHEDULED = "LOADING_UNSCHEDULED";
export const LOADING_EDIT_STOP = "LOADING_EDIT_STOP";
export const SET_VEHICLES_LIST_LOADED = "SET_VEHICLES_LIST_LOADED";
export const SET_DRIVERS_LIST_LOADED = "SET_DRIVERS_LIST_LOADED";
export const SET_TAGS_LIST_LOADED = "SET_TAGS_LIST_LOADED";
export const SET_TEMPLATES_LIST_LOADED = "SET_TEMPLATES_LIST_LOADED";
export const SET_DETERMINATE_LOADING = "SET_DETERMINATE_LOADING";

// Edit
export const SET_EXTENDABLE_TYPE = "SET_EXTENDABLE_TYPE";
export const SET_EXTENDABLE_ID = "SET_EXTENDABLE_ID";
export const SET_EXTENDABLE_BACK_TO = "SET_EXTENDABLE_BACK_TO";
export const SET_EXTENDABLE_SAVE_DISABLED = "SET_EXTENDABLE_SAVE_DISABLED";

// Map
export const MAP_BOUNDS = "MAP_BOUNDS";
export const MAP_POLYLINES = "MAP_POLYLINES";
export const MAP_HIDDEN_ROUTES = "MAP_HIDDEN_ROUTES";
export const MAP_MARKERS_HIDDEN = "MAP_MARKERS_HIDDEN";
export const MAP_UNSCHEDULED_MARKERS_HIDDEN = "MAP_UNSCHEDULED_MARKERS_HIDDEN";
export const MAP_MARKERS_CLUSTERED = "MAP_MARKERS_CLUSTERED";
export const MAP_LAYERS_HIDDEN = "MAP_LAYERS_HIDDEN";
export const MAP_TILES_DARK = "MAP_TILES_DARK";
export const MAP_HOVER_STOP = "MAP_HOVER_STOP";
export const MAP_CURRENT_DRIVER = "MAP_CURRENT_DRIVER";
export const MAP_PINPOINT_DRIVER = "MAP_PINPOINT_DRIVER";
export const SET_DRIVER_LIVE = "SET_DRIVER_LIVE";
export const SET_RENDERED_POLYLINES = "SET_RENDERED_POLYLINES";
export const MAP_SNAP_TO_ROAD_VISIBLE = "MAP_SNAP_TO_ROAD_VISIBLE";
export const SET_MAP_ZOOM = "SET_MAP_ZOOM";
export const SET_REFIT_HASH = "SET_REFIT_HASH";
export const SET_MAP_CENTER = "SET_MAP_CENTER";
export const MAP_IS_DRIVER_LIVE_LOCATION_VISIBLE =
  "MAP_IS_DRIVER_LIVE_LOCATION_VISIBLE";

// Common
export const DRAWER = "DRAWER";
export const DASHBOARD_LOADING = "DASHBOARD_LOADING";
export const PROJECT_OPTIONS = "PROJECT_OPTIONS";
export const PROJECT_TAB_VALUE = "PROJECT_TAB_VALUE";
export const DRAGGING_TYPE = "DRAGGING_TYPE";
export const DRAG_SELECTION = "DRAG_SELECTION";
export const SET_FILTER_STATUS = "SET_FILTER_STATUS";
export const FILTER_VEHICLES_BY_STATUS = "FILTER_VEHICLES_BY_STATUS";
export const SET_CURRENT_WINDOW = "SET_CURRENT_WINDOW";
export const SET_SETTINGS_SAVE_DISABLED = "SET_SETTINGS_SAVE_DISABLED";
export const SET_INFO_DIALOG_STATE = "SET_INFO_DIALOG_STATE";
export const SET_INCOMPLETE_DRAWER_VISIBLE = "SET_INCOMPLETE_DRAWER_VISIBLE";
export const SET_PROJECTS_DISABLED = "SET_PROJECTS_DISABLED";
export const SET_COUNTRY = "SET_COUNTRY";
export const SET_PUBLISH_DISABLED = "SET_PUBLISH_DISABLED";
export const SET_CURRENT_PROJECT_ID = "SET_CURRENT_PROJECT_ID";
export const SET_DISABLED_VEHICLES_VISIBILITY =
  "SET_DISABLED_VEHICLES_VISIBILITY";
export const SET_ALL_VEHICLES_SELECTED = "SET_ALL_VEHICLES_SELECTED";
export const SET_UPLOAD_STOPS_OPEN = "SET_UPLOAD_STOPS_OPEN";
export const SET_UPLOAD_STOPS_SIMPLE_OPEN = "SET_UPLOAD_STOPS_SIMPLE_OPEN";
export const SET_OPTIONS_EXPANDED = "SET_OPTIONS_EXPANDED";
export const SET_STOP_TO_SCROLL_ID = "SET_STOP_TO_SCROLL_ID";
export const SET_STOP_SEARCH_MODE = "SET_STOP_SEARCH_MODE";
export const SET_STOP_SELECT_MODE = "SET_STOP_SELECT_MODE";
export const SET_ROUTES_SEARCH_MODE = "SET_ROUTES_SEARCH_MODE";
export const ADD_DRIVER_DIALOG_OPENED = "ADD_DRIVER_DIALOG_OPENED";

// Snackbars
export const ENQUEUE_SNACKBAR = "ENQUEUE_SNACKBAR";
export const CLOSE_SNACKBAR = "CLOSE_SNACKBAR";
export const REMOVE_SNACKBAR = "REMOVE_SNACKBAR";

// Account
export const SET_ACCOUNT_DRAWER_OPEN = "SET_ACCOUNT_DRAWER_OPEN";
export const SET_PROJECTS = "SET_PROJECTS";
export const SET_APP_PROJECTS = "SET_APP_PROJECTS";
export const SET_APP_STOPS = "SET_APP_STOPS";
export const SET_PROJECTS_QUANTITY = "SET_PROJECTS_QUANTITY";
export const RESET_ACCOUNT_STATE = "RESET_ACCOUNT_STATE";
export const SET_WEBHOOKS = "SET_WEBHOOKS";
export const SET_WEBHOOK_EVENT_TYPES = "SET_WEBHOOK_EVENT_TYPES";
export const SET_ACTIVE_DIALOG = "SET_ACTIVE_DIALOG";
export const SET_BILLING_OPEN = "SET_BILLING_OPEN";
export const SET_PAYMENT = "SET_PAYMENT";
export const SET_BILLING_DETAILS = "SET_BILLING_DETAILS";
export const SET_CURRENT_PRICING_DIALOG = "SET_CURRENT_PRICING_DIALOG";
export const SET_INVOICES = "SET_INVOICES";
export const SET_API_KEYS = "SET_API_KEYS";
export const SET_TAGS = "SET_TAGS";
export const SET_TEMPLATES = "SET_TEMPLATES";
export const SET_APPS = "SET_APPS";
